import React, {useEffect} from 'react';
import '../styles/Services.css'; // You can create this file for specific styling

const Services = () => {
    useEffect(() => {
        document.title = 'Services | Bularis Tech';
        }, []);
      
  return (
    <div className="services">
      <div className="services-header">
        <h1>Our Services</h1>
        <p>We offer a wide range of services to help your business grow.</p>
      </div>
      <div className="service">
        <h2>Web Development</h2>
        <p>We build custom websites that are fast, secure, and mobile-friendly.</p>
      </div>
      <div className="service">
        <h2>Mobile App Development</h2>
        <p>We create mobile apps that provide seamless user experiences and are tailored to your business needs.</p>
      </div>
      <div className="service">
        <h2>E-commerce Solutions</h2>
        <p>Our e-commerce solutions help you manage your online store, increase sales, and improve customer experience.</p>
      </div>
    </div>
  );
}

export default Services;
